export default __webpack_public_path__ + "static/media/Bed, Orange.e4cbcb70.png";